import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6fd2ab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CalculationUpdateGrid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-semibold" }, "Отправитель", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-semibold" }, "Плательщик", -1))
const _hoisted_4 = { class: "flex items-center justify-between mb-2 mt-4 pt-2 border-t" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Доп. услуги", -1))
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "CalculationUpdateGrid"
}
const _hoisted_11 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "xxl",
    title: _ctx.title,
    "confirm-button-text": "Сохранить",
    "is-confirm": false,
    scrollable: "",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.updateCalculation
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createVNode(_component_the_select, {
            placeholder: "Отправитель",
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "error-text": "При получении списка отправителей произошла ошибка",
            options: _ctx.data_state.companies.list,
            value: _ctx.payload.companyId,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.companyId) = $event)),
            "is-invalid": _ctx.state_form$.companyId.$error,
            "validation-errors": _ctx.state_form$.companyId.$errors,
            "infinite-scroll": "",
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
            onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
            onSearch: _ctx.searchCompanies,
            onOptionBySearch: _ctx.unshiftFindedCompany
          }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_component_the_select, {
            placeholder: "Плательщик",
            loading: _ctx.data_state.payers.is_loading,
            failed: _ctx.data_state.payers.is_failed,
            "error-text": "При получении списка отправителей произошла ошибка",
            options: _ctx.data_state.payers.list,
            value: _ctx.payload.payerCompanyId,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.payerCompanyId) = $event)),
            "is-invalid": _ctx.state_form$.payerCompanyId.$error,
            "validation-errors": _ctx.state_form$.payerCompanyId.$errors,
            "infinite-scroll": "",
            onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadPayers(_ctx.data_state.payers.pagination.current_page))),
            onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMorePayers(_ctx.data_state.payers.pagination.current_page + 1))),
            onSearch: _ctx.searchPayers,
            onOptionBySearch: _ctx.unshiftFindedPayer
          }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch"])
        ]),
        _createVNode(_component_the_input, {
          placeholder: "Вес в кг",
          value: _ctx.payload.weightInKg,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.weightInKg) = $event)),
          "is-invalid": _ctx.state_form$.weightInKg.$error,
          "validation-errors": _ctx.state_form$.weightInKg.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Объемный вес в кг",
          value: _ctx.payload.volumeWeightInKg,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payload.volumeWeightInKg) = $event)),
          "is-invalid": _ctx.state_form$.volumeWeightInKg.$error,
          "validation-errors": _ctx.state_form$.volumeWeightInKg.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Объявленная стоимость",
          value: _ctx.payload.declaredPrice,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payload.declaredPrice) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          placeholder: "Тип отправки",
          options: _ctx.SHIPMENT_TYPE_OPTIONS,
          value: _ctx.payload.shipmentType,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payload.shipmentType) = $event)),
          class: "mt-2",
          searchable: false,
          "is-invalid": _ctx.state_form$.shipmentType.$error,
          "validation-errors": _ctx.state_form$.shipmentType.$errors
        }, null, 8, ["options", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_select, {
          placeholder: "Зона",
          options: _ctx.ZONE_OPTIONS,
          value: _ctx.payload.zone,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payload.zone) = $event)),
          class: "mt-2",
          searchable: false,
          "is-invalid": _ctx.state_form$.zone.$error,
          "validation-errors": _ctx.state_form$.zone.$errors
        }, {
          "selected-option": _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(option.name ? `Зона: ${option.name}` : 'Зона'), 1)
          ]),
          option: _withCtx(({ option }) => [
            _createTextVNode(" Зона: " + _toDisplayString(option.name), 1)
          ]),
          _: 1
        }, 8, ["options", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата доставки",
          value: _ctx.payload.deliveredAt,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.payload.deliveredAt) = $event)),
          "is-invalid": _ctx.state_form$.deliveredAt.$error,
          "validation-errors": _ctx.state_form$.deliveredAt.$errors,
          type: "date"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "Штрих-Код",
          value: _ctx.payload.barcode,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payload.barcode) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.getAdditionalServices.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.state.is_add_additional_service)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_the_select, {
                      placeholder: "Доп. услуга",
                      options: _ctx.getAdditionalServices,
                      value: _ctx.state.additional_service_code,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.additional_service_code) = $event)),
                      "select-by": "code"
                    }, null, 8, ["options", "value"]),
                    _createVNode(_component_the_button, {
                      class: "primary small ml-2",
                      hint: "Подтвердить",
                      "hint-color": "text-white",
                      onClick: _ctx.addAdditionalService
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createBlock(_component_the_button, {
                    key: 1,
                    class: "primary small",
                    hint: "Добавить доп. услугу",
                    "hint-color": "text-white",
                    onClick: _ctx.toggleAddAdditionalService
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.payload.additionalServices.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.additionalServices, (service, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `a-s-${idx}`
              }, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.getServiceName(service)), 1),
                _createVNode(_component_the_input, {
                  class: "w-full mt-2",
                  placeholder: "Кол-во",
                  value: _ctx.payload.additionalServices[idx].value,
                  "onUpdate:value": ($event: any) => ((_ctx.payload.additionalServices[idx].value) = $event),
                  type: "number",
                  "return-number": ""
                }, null, 8, ["value", "onUpdate:value"]),
                (_ctx.isCanRenderDuration(service))
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 0,
                      class: "w-full mt-2",
                      placeholder: "Общее затраченное время",
                      value: _ctx.payload.additionalServices[idx].duration,
                      "onUpdate:value": ($event: any) => ((_ctx.payload.additionalServices[idx].duration) = $event),
                      type: "number",
                      "return-number": ""
                    }, null, 8, ["value", "onUpdate:value"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanRenderCost(service))
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 1,
                      class: "w-full mt-2",
                      placeholder: "Себестоимость за час",
                      value: _ctx.payload.additionalServices[idx].costPerHour,
                      "onUpdate:value": ($event: any) => ((_ctx.payload.additionalServices[idx].costPerHour) = $event),
                      type: "number",
                      "return-number": ""
                    }, null, 8, ["value", "onUpdate:value"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "loading", "onCancel", "onConfirm"]))
}